import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useStateValue } from 'context/app';
import {
  ACTION_CITY_DETAILS_ERROR_RESET,
  getCityDetails
} from 'containers/Account/actions';
import dateFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { reloadAddress } from 'containers/Checkout/actions';
import { translate } from 'constants/language';
import { getCustomerId } from 'utils/user';
import { getDeliverySlaArea } from 'utils/address';
import { isBrowser } from 'react-device-detect';
import { getStoreId, getStoreCurrentTimeDiff, validatePincode } from 'utils/';
import Input from 'components/libs/Input';
import LocationIcon from 'assets/icons/location-icon.svg';
import BoxIcon from 'assets/icons/box-icon-24.svg';
import { COUNTRY } from 'constants/index';
import FlexSlidePane from 'components/libs/SlidePane/FlexSlidePane';
import CloseIcon from 'assets/icons/icon-cancel-black.svg';
import ArrowDownBlk from 'assets/icons/arrow-down.svg';

export default ({ inModal = false, getDefaultFromConfig = false }) => {
  const {
    account: [accountState, accountDispatch],
    shipping: [shippingState, shippingDispatch]
  } = useStateValue();
  const [timeDiffString, setTimeDiff] = useState('');
  const [areaError, setAreaError] = useState('');

  const {
    config: { deliverySlaConfigs } = {},
    cityDetails = {},
    cityDetailsError = false,
    cityDetailsLoading = false
  } = accountState;

  const { provincesNew: provinceData } = shippingState;

  const {
    addresses: customerAddressData = [],
    defaultCityDetails = {}
  } = shippingState;
  const [defaultAddressData, setDefaultAddressData] = useState({});
  const [savedCityChecked, setSavedCityCheck] = useState(false);
  const [selectedArea, setArea] = useState(null);

  useEffect(() => {
    reloadAddress({}, shippingDispatch);
  }, []);

  const handleAddressCity = finalArea => {
    if (finalArea) {
      getCityDetails(
        {
          citySearchKey: finalArea,
          defaultCityId: defaultCityDetails.name_en,
          updateLocalArea: true
        },
        accountDispatch
      );
    }
  };

  useEffect(() => {
    if (
      provinceData &&
      defaultCityDetails &&
      defaultCityDetails.name_en &&
      !savedCityChecked
    ) {
      getDeliverySlaArea().then(pdpArea => {
        if (pdpArea) {
          setArea(pdpArea);
          return '';
        }
        const customerId = getCustomerId();
        setArea(defaultCityDetails.name_en);
        if (customerId) {
          if (customerAddressData && customerAddressData.length) {
            const filteredAddress = customerAddressData.filter(
              adrs => adrs.enabled
            );
            let finalAddress = {};
            if (filteredAddress.length) {
              const defaultCustomerAddress =
                filteredAddress.find(adrs => adrs.defaultAddress) || {};
              finalAddress = defaultCustomerAddress.city
                ? defaultCustomerAddress
                : filteredAddress[0];
            }

            handleAddressCity(finalAddress.area || '');
            setSavedCityCheck(true);
          }
        }
        return '';
      });
    }
  }, [customerAddressData, defaultCityDetails, provinceData, savedCityChecked]);

  useEffect(() => {
    if (cityDetails.id && deliverySlaConfigs) {
      let slaDate;
      let serviceableError;
      if (cityDetails.enabled) {
        slaDate = cityDetails.estimated_date
          ? dateFormat(
              new Date(parseISO(cityDetails.estimated_date)),
              'EEE, do LLL'
            )
          : '';
        if (!slaDate) {
          const factor =
            deliverySlaConfigs && deliverySlaConfigs.use_min_sla
              ? cityDetails.min_sla
              : cityDetails.max_sla;

          slaDate = dateFormat(
            new Date(new Date().getTime() + 86400000 * factor),
            'EEE, do LLL'
          );
        }

        const timezone =
          deliverySlaConfigs.timezone &&
          deliverySlaConfigs.timezone[getStoreId()];
        let cutOffStr = '';
        if (!cityDetails.cutoff_time_excluded && cityDetails.cut_off_time) {
          const { hrsDiff, minDiff } = getStoreCurrentTimeDiff(
            cityDetails.cut_off_time,
            timezone
          );

          if (hrsDiff || minDiff) {
            cutOffStr = `${translate('When you order in')} ${
              hrsDiff ? `${hrsDiff} ${translate('hours')}` : ''
            } ${minDiff ? `${minDiff} ${translate('mins')}` : ''}`;
          }
        }
        setTimeDiff(cutOffStr);
        setAreaError('');
      } else {
        serviceableError = 'Pincode not serviceable';
        setAreaError('Pincode not serviceable');
      }
      setDefaultAddressData({ ...cityDetails, slaDate, serviceableError });
    }
  }, [cityDetails]);

  useEffect(() => {
    if (selectedArea) {
      getCityDetails(
        {
          citySearchKey: selectedArea,
          defaultCityId: defaultCityDetails.name_en,
          updateLocalArea: savedCityChecked
        },
        accountDispatch
      );
    }
  }, [selectedArea]);
  const [areaInputValue, setAreaInputValue] = useState('');
  const [isCityDetailsRequested, setIsCityDetailsRequested] = useState(false);

  const getAreaData = () => {
    if (areaInputValue && validatePincode(areaInputValue) === true) {
      setIsCityDetailsRequested(true);
      getCityDetails(
        {
          citySearchKey: areaInputValue,
          defaultCityId: defaultCityDetails.name_en,
          updateLocalArea: true,
          isPincodeSearch: true
        },
        accountDispatch
      );
    } else {
      setAreaError(validatePincode(areaInputValue) || 'incorrect Pincode.');
    }
  };

  useEffect(() => {
    if (isCityDetailsRequested && cityDetailsError === true) {
      setAreaError('Pincode not serviceable');
      setIsCityDetailsRequested(false);
    } else {
      setAreaError('');
    }
  }, [cityDetailsError]);

  useEffect(() => {
    if (
      getDefaultFromConfig === true &&
      COUNTRY.toLowerCase() === 'in' &&
      deliverySlaConfigs &&
      deliverySlaConfigs.pincode_config &&
      deliverySlaConfigs.pincode_config[COUNTRY] &&
      deliverySlaConfigs.pincode_config[COUNTRY].default_pincode
    ) {
      setAreaInputValue(
        deliverySlaConfigs.pincode_config[COUNTRY].default_pincode
      );
      getCityDetails(
        {
          citySearchKey:
            deliverySlaConfigs.pincode_config[COUNTRY].default_pincode,
          defaultCityId:
            deliverySlaConfigs.pincode_config[COUNTRY].default_pincode,
          updateLocalArea: true,
          isPincodeSearch: true
        },
        accountDispatch
      );
    }
  }, [deliverySlaConfigs, getDefaultFromConfig]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onClose = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (cityDetails && cityDetails.id && cityDetails.enabled) {
      setIsModalOpen(false);
    }
  }, [cityDetails]);
  return (
    <If condition={deliverySlaConfigs && deliverySlaConfigs.enable_feature}>
      <If
        condition={
          inModal &&
          defaultAddressData.id &&
          defaultAddressData.name_en &&
          (defaultAddressData.slaDate || defaultAddressData.serviceableError)
        }
      >
        <div className="bg-white pt-8 pb-8 flex center-xs mb-8">
          <div className="fs-10 lh-16 ls-04 c-main-black flex middle-xs">
            <div>{translate('Delivery to')}</div>
            <div
              className="flex middle-xs"
              role="button"
              onClick={() => setIsModalOpen(true)}
              onKeyPress={() => setIsModalOpen(true)}
            >
              <div className="fs-11 fw-6 ml-4 mr-4">
                {defaultAddressData.name_en}
              </div>
              <div className="mr-4">
                <ArrowDownBlk />
              </div>
            </div>
            <Choose>
              <When condition={defaultAddressData.serviceableError}>
                <div className="c-error">
                  {defaultAddressData.serviceableError}
                </div>
              </When>
              <Otherwise>
                <div>
                  {translate('by')} {defaultAddressData.slaDate}
                </div>
              </Otherwise>
            </Choose>
          </div>
        </div>
      </If>
      <If condition={!inModal}>
        <hr
          className={classnames(' mb-16', {
            'h-8 ml-n-15 mr-n-15 bg-yellow-gray-300': !isBrowser,
            'bg-very-light-pink-gray': isBrowser
          })}
        />
      </If>
      <If
        condition={!inModal && defaultAddressData && defaultAddressData.name_en}
      >
        <div
          className={classnames('pt-8 pb-8 fs-12 c-dark-gray', {
            'mb-16 bg-dark-gray': isBrowser,
            'c-greyish-brown': !isBrowser
          })}
          style={
            isBrowser
              ? {
                  backgroundColor: deliverySlaConfigs.sla_colors.pdp,
                  color: deliverySlaConfigs.sla_colors.pdp_text
                }
              : {}
          }
        >
          <div>
            <If
              condition={
                defaultAddressData.slaDate ||
                defaultAddressData.serviceableError
              }
            >
              <div className="flex between-xs middle-xs mb-8">
                <div
                  className={classnames(
                    'fw-6 flex middle-xs',
                    isBrowser ? 'fs-14 lh-18 ls-064' : 'lh-14'
                  )}
                >
                  <div className="mr-10">
                    <LocationIcon className="d-block" />
                  </div>
                  <div>Delivering to {defaultAddressData.name_en}</div>
                </div>
                <a
                  className="c-brand fs-14 fw-6 cap c-green"
                  onClick={() => setDefaultAddressData({})}
                  onKeyPress={() => setDefaultAddressData({})}
                  role="button"
                  id="applyCoupon"
                >
                  {translate('Change')}
                </a>
              </div>
              <Choose>
                <When condition={defaultAddressData.serviceableError}>
                  <div className="fs-14 lh-18 ls-064 c-error mt-10">
                    {defaultAddressData.serviceableError}
                  </div>
                </When>
                <Otherwise>
                  <div className="flex">
                    <div className="mr-10">
                      <BoxIcon className="d-block" />
                    </div>
                    <div>
                      <div className="fs-14 lh-18 ls-064">
                        {translate('Delivery by')}&nbsp;
                        <span className="fw-6 en-font">
                          {defaultAddressData.slaDate}
                        </span>
                      </div>
                      <If condition={timeDiffString}>
                        <div className="c-brown-gray mt-2">
                          {timeDiffString}
                        </div>
                      </If>
                    </div>
                  </div>
                </Otherwise>
              </Choose>
            </If>
          </div>
        </div>
      </If>
      <If
        condition={
          !defaultAddressData || !defaultAddressData.name_en || inModal
        }
      >
        <FlexSlidePane
          isOpen={isModalOpen || !inModal}
          from="bottom"
          width="100%"
          contentClassName=""
          onRequestClose={onClose}
          overlayClassName="z-100"
          isCenter={true}
          inModal={inModal}
        >
          <If condition={inModal}>
            <div className="flex middle-xs bb-white-badge pb-16 pt-16 pl-15 pr-15 mb-16">
              <div className="fs-16 ls-05 c-main-black fw-6 flex middle-xs">
                {translate('Enter your pincode')}
              </div>

              <a
                className="mr-0 ml-auto"
                role="button"
                onClick={onClose}
                onKeyPress={onClose}
              >
                <CloseIcon className="d-block" />
              </a>
            </div>
          </If>
          <div className={classnames('pb-15', { 'pl-15 pr-15': inModal })}>
            <div>
              <If condition={!inModal}>
                <div className="fs-13 fw-5">{translate('Delivery for')}</div>
              </If>
              <Choose>
                <When condition={cityDetailsLoading}>
                  <div className="pt-12 pb-4 flex center-xs">
                    <div className="loader" />
                  </div>
                </When>
                <Otherwise>
                  <div
                    className={classnames(
                      'flex middle-xs b-brown-grey pt-10 pb-10 br-1 mt-8 br-3',
                      {
                        'b-pastel-red': areaError && areaError.length
                      }
                    )}
                  >
                    <Input
                      id="couponInput"
                      value={areaInputValue}
                      wrapClassNames="w100p"
                      className="w100p fw-5 c-dark-gray b-none h-25 en-font"
                      placeholder={translate('Enter Pincode')}
                      maxLength="6"
                      onChange={e => {
                        const val = e.target.value.replace(/\D/g, '');
                        setAreaInputValue(val);
                        setAreaError('');
                        accountDispatch({
                          type: ACTION_CITY_DETAILS_ERROR_RESET
                        });
                        setIsCityDetailsRequested(false);
                      }}
                    />

                    <If condition={areaInputValue}>
                      <a
                        className={classnames(
                          'c-brand fs-14 fw-6 ml-16 mr-16 cap c-green',
                          { 'pointer-e-none o-50': areaInputValue.length !== 6 }
                        )}
                        onClick={getAreaData}
                        onKeyPress={getAreaData}
                        role="button"
                        id="applyCoupon"
                      >
                        {translate('Check')}
                      </a>
                    </If>
                  </div>
                  <If condition={areaError.length > 0}>
                    <div className="fs-13 c-pastel-red lh-8 mt-6">
                      {translate(areaError)}
                    </div>
                  </If>
                </Otherwise>
              </Choose>
            </div>
          </div>
        </FlexSlidePane>
      </If>
      <If condition={!inModal}>
        <hr
          className={classnames(' mb-16 mt-10', {
            'h-8 ml-n-15 mr-n-15 bg-yellow-gray-300': !isBrowser,
            'bg-very-light-pink-gray': isBrowser
          })}
        />
      </If>
    </If>
  );
};
